import * as Yup from 'yup';

export const addCustomerValidation = Yup.object().shape({
  customerName: Yup.string().required('Required'),
  sapid: Yup.string().required('Required'),
  emailID: Yup.string().email('Invalid email').required('Required'),
});

export const addApplicationValidation = Yup.object().shape({
  name: Yup.string().required('Required'),
  code: Yup.string().required('Required'),
  secretKey: Yup.string().required('Required'),
  audienceKey: Yup.string().required('Required'),
  url: Yup.string().required('Required'),
  description: Yup.string().optional(),
});

export const addRolesValidations = Yup.object().shape({
  roleName: Yup.string().required('Required'),
  appAccess: Yup.array().of(Yup.string().required('Required')).min(1, 'Required'),
  notes: Yup.string().required('Required'),
});

export const addProjectValidation = Yup.object().shape({
  customer: Yup.string().required('Required'),
  projectName: Yup.string().required('Required'),
  startDate: Yup.string().required('Required'),
  endDate: Yup.string().required('Required'),
  personInCharge: Yup.string().optional(),
  personInChargeEmail: Yup.string().email().optional(),
  accountManager: Yup.string().optional(),
  accountManagerEmail: Yup.string().email().optional(),
  sapId: Yup.string().required('Required'),
  notes: Yup.string().optional(),
  maxUserCount: Yup.string().required('Required'),
});

export const addUserValidation = Yup.object().shape({
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
  phoneNumber: Yup.string().required('Required'),
  email: Yup.string().email().required('Required'),
  status: Yup.string().required('Required'),
  userRole: Yup.string().required('Required'),
  countryCode: Yup.string().required('Required'),
  loginEmail: Yup.string().required('Required').matches(/^\S*$/, 'spaces not allowed'),
  customers: Yup.array().of(
    Yup.object().shape({
      customer: Yup.string().required('Required'),
      projects: Yup.array()
        .of(Yup.string().required('Required'))
        .min(1, 'Required')
        .required('Required'),
    }),
  ),
});

export const loginValidation = Yup.object().shape({
  userName: Yup.string().required('Required'),
});

export const otpValidation = Yup.object().shape({
  code: Yup.string().required('Required'),
});

export const updateUserProfileValidation = Yup.object().shape({
  phoneNumber: Yup.number(),
  email: Yup.string().email(),
  code: Yup.string().required('OTP is Required'),
});

export const loginSettingsValidation = Yup.object().shape({
  // firstName: Yup.string().required('Required'),
  slides: Yup.array().of(
    Yup.object().shape({
      title: Yup.string(),
      desc: Yup.string(),
    }),
  ),
});

export const sendNotificationValidation = Yup.object().shape({
  type: Yup.string().required('Required'),
  sendTo: Yup.string().required('Required'),
  message: Yup.string().required('Required'),
  title: Yup.string().required('Required'),
  ids: Yup.string().when('sendTo', {
    is: (val) => val !== 'all',
    then: (schema) =>
      schema
        .matches(/^[\w@.]+(?:,[\w@.]+)*$/, 'Please enter comma separated ids')
        .required('Required'),
    otherwise: (schema) => schema.optional(),
  }),
});

export const FeedbackValidation = Yup.object().shape({
  message: Yup.string().trim().required('Feedback message is required'),
});
